import useSWR from 'swr';

import { fetchSegment } from 'src/store/api';

function fetcher(segmentId, options) {
  if (!segmentId) {
    return undefined;
  }
  return fetchSegment(segmentId, options);
}

export default function useSegment({ segmentId, options = {}, config = { shouldFetch: true } }) {
  const { shouldFetch } = config;

  const url = `/core/v1/segments/${segmentId}`;

  return useSWR(
    shouldFetch ? { key: url, segmentId, options } : null,
    ({ segmentId: s, options: o }) => fetcher(s, o),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    }
  );
}
